import { useRef, useEffect, useCallback } from 'react';
import { ISourceTimelineEventType } from '@24i/player-base';
import { usePlayerUIContext } from '../Context/ui';
import { bingeWatchingOverlayShow, bingeWatchingOverlayHide, bingeWatchingOverlaySetRemainingTime, showUI, } from '../Context/ui/actions';
const COUNTDOWN_SECONDS = 15;
const DEFAULT_CREDITS_OFFSET_SECONDS = 15;
export const useBingeWatchingOverlay = ({ playerInstance, asset, hasNextEpisode, onGoToNextEpisode, }) => {
    const { state: { bingeWatchingOverlay: { isOpen, isDismissed, remainingTime }, }, dispatch, } = usePlayerUIContext();
    const isInCreditsRef = useRef(false);
    const tickTimerRef = useRef();
    const onHide = useCallback(() => {
        dispatch(bingeWatchingOverlayHide(true));
        dispatch(showUI());
    }, []);
    const onNext = useCallback(() => {
        var _a;
        dispatch(bingeWatchingOverlayHide(false));
        const postAd = (_a = playerInstance === null || playerInstance === void 0 ? void 0 : playerInstance.adBreaks) === null || _a === void 0 ? void 0 : _a.find((adStart) => adStart > (playerInstance === null || playerInstance === void 0 ? void 0 : playerInstance.currentTime));
        if (postAd) {
            playerInstance.seek(postAd);
        }
        else if (onGoToNextEpisode) {
            playerInstance.pause();
            onGoToNextEpisode(asset);
        }
    }, [asset]);
    useEffect(() => {
        isInCreditsRef.current = false;
        dispatch(bingeWatchingOverlayHide(false));
    }, [asset === null || asset === void 0 ? void 0 : asset.id]);
    useEffect(() => {
        const shouldCheck = !!(playerInstance && hasNextEpisode);
        if (!shouldCheck) {
            return () => {
            };
        }
        const onTimeUpdate = (event) => {
            const duration = Math.floor(playerInstance.duration / 1000) * 1000;
            const currentTime = Math.floor(event.currentTime / 1000) * 1000;
            const timeline = playerInstance.timeline || [];
            const credits = timeline.filter(({ type, start }) => type === ISourceTimelineEventType.CREDITS &&
                start < duration - DEFAULT_CREDITS_OFFSET_SECONDS * 1000);
            if (!credits.length && duration) {
                credits.push({
                    type: ISourceTimelineEventType.CREDITS,
                    start: duration - DEFAULT_CREDITS_OFFSET_SECONDS * 1000,
                    end: duration,
                });
            }
            const nextIsInCredits = credits.some((timelineEvent) => {
                const { start } = timelineEvent;
                return currentTime >= start - 500;
            });
            if (nextIsInCredits === isInCreditsRef.current) {
                return;
            }
            isInCreditsRef.current = nextIsInCredits;
            const secondsFromEnd = Math.floor((duration - currentTime) / 1000);
            if (nextIsInCredits) {
                dispatch(bingeWatchingOverlayShow(Math.min(COUNTDOWN_SECONDS, secondsFromEnd)));
            }
            else {
                dispatch(bingeWatchingOverlayHide(false));
            }
        };
        playerInstance.addEventListener('timeupdate', onTimeUpdate);
        return () => playerInstance.removeEventListener('timeupdate', onTimeUpdate);
    }, [playerInstance, hasNextEpisode]);
    useEffect(() => {
        if (!isOpen) {
            clearTimeout(tickTimerRef.current);
        }
    }, [isOpen]);
    useEffect(() => {
        if (remainingTime === 0) {
            onNext();
        }
        else if (remainingTime > 0) {
            tickTimerRef.current = setTimeout(() => {
                dispatch(bingeWatchingOverlaySetRemainingTime(remainingTime - 1));
            }, 1000);
        }
        return () => clearTimeout(tickTimerRef.current);
    }, [remainingTime]);
    return {
        isOpen,
        isDismissed,
        remainingTime,
        onHide,
        onNext,
    };
};
//# sourceMappingURL=useBingeWatchingOverlay.js.map